export default function Staff() {
  const staffMembers = [
    {
      name: '吉原 将広',
      role: '代表取締役 / 施工責任者',
      experience: '業界歴6年',
      hobby: '休日は愛犬とドッグラン',
      message: '信頼を第一に、誠実なご提案と施工を心がけています。お客様の課題や悩みを全力で解決しますのでお気軽にご相談ください!',
      image: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/d7d89c613e17cd7c6f6f7b9798ad6dff.jpeg'
    },
    {
      name: '下村 奈生',
      role: '営業主任',
      experience: '業界歴4年',
      hobby: '筋トレと仏閣巡り',
      message: 'お客様の不安や疑問に、いつでも寄り添います。どんな些細な事でもご相談くださいね。',
      image: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/052e11e07f9a8e5b92903e09ba262d7a.jpeg'
    },
    {
      name: '菅野 香織',
      role: '事務スタッフ',
      experience: '',
      hobby: 'お酒',
      message: '誠実な対応を心がけています。お電話の際は私がご対応させていただきます。',
      image: '',
      isIcon: true
    }
  ];

  return (
    <section id="staff" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#ff8c42] font-bold text-base mb-4">スタッフ紹介</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1a2b4a] mb-6">
            どんな人が家に来るか<br />顔が見えるから安心
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            「どんな人が来るんだろう…」という不安を解消するため、<br />
            湧水堂スタッフの顔と人柄をご紹介します。
          </p>
        </div>

        {/* Staff Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {staffMembers.map((staff, index) => (
            <div 
              key={index}
              className="bg-gradient-to-b from-gray-50 to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
            >
              {/* Photo or Icon */}
              <div className="relative w-full h-80 bg-gradient-to-br from-pink-100 to-pink-50 flex items-center justify-center">
                {staff.isIcon ? (
                  <div className="w-32 h-32 flex items-center justify-center">
                    <i className="ri-user-3-fill text-8xl text-pink-300"></i>
                  </div>
                ) : (
                  <img 
                    src={staff.image}
                    alt={staff.name}
                    className="w-full h-full object-cover object-top"
                  />
                )}
              </div>

              {/* Info */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#1a2b4a] mb-2">
                  {staff.name}
                </h3>
                <p className="text-sm text-[#ff8c42] font-bold mb-1">
                  {staff.role}
                </p>
                {staff.experience && (
                  <p className="text-sm text-gray-600 mb-4">
                    {staff.experience}
                  </p>
                )}
                
                <div className="flex items-center gap-2 mb-4 text-sm text-gray-600">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-heart-fill text-[#ff8c42]"></i>
                  </div>
                  <span>{staff.hobby}</span>
                </div>

                <p className="text-sm text-gray-700 leading-relaxed">
                  {staff.message}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}